import { render } from "./FileStoragePage.vue?vue&type=template&id=2de95b22"
import script from "./FileStoragePage.vue?vue&type=script&lang=js"
export * from "./FileStoragePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__